export class DtoValueOnSelect<T> {
  label: string = ''
  value: string | number = ''
  dataComplete: T = {} as T
}